import { Button } from '@mantine/core';
import React from 'react';
import { useNavigate } from 'react-router';
import { generatePath, useLocation, useParams } from 'react-router-dom';

import { rootRoutes } from '../../../../app/routers/rootRoutes';
import { TaskActionDto } from '../../../../shared/model/tasks/types';
import { TaskActions } from '../../../../shared/ui/TaskActions';

type Props = {
  values: TaskActionDto[];
};

export const ApproveActions: React.FC<Props> = ({ values }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { taskId } = useParams();

  const handleClick = (id: string) => () => {
    navigate(generatePath(rootRoutes.taskComment, { taskId, id }), {
      state: {
        goBackTask: location.state?.goBackTask,
        goBackTaskComment: location.pathname,
      },
    });
  };

  return (
    <TaskActions>
      {values.map(({ nameField, idField }) => (
        <Button variant="outline" key={nameField} onClick={handleClick(idField)}>
          {nameField}
        </Button>
      ))}
    </TaskActions>
  );
};
